module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Db-Ee-Fb-Gb.422827b2.png";